<template>
    <div class="private-layout">
        <SideNavBar />
        <TopRightBar />
        <div class="private-layout__wrapper">
            <slot></slot>
        </div>
        
    </div>
    
</template>
<script setup>
import SideNavBar from "../components/SideNavBar/SideNavBar.vue";
import TopRightBar from "../components/TopRightBar/TopRightBar.vue";
import { useChat } from "@/composables/useChat.js";

const { initializeChat } = useChat();
initializeChat();
</script>
<style lang="scss" scoped>
.private-layout {
    display: flex;
    flex-direction: row;
    height: 100vh;
    width: 100vw;

    &__wrapper {
        width: 100%;
        padding: 1rem;
        overflow: auto;
        overflow-x: hidden;
    }
}

</style>